// extracted by mini-css-extract-plugin
export var bold = "_z8-0";